import { Injectable } from '@angular/core';

import { TmsWebBaseEditService } from 'tms-web-shared';
import { Operator } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class OperatorService extends TmsWebBaseEditService<Operator, Operator> {
  constructor() {
    super('Operator', $localize`Operator`);
  }
}
